/* SET STATE */
export const SET_STATE_LABREQUESTREPORT = "SET_STATE_LABREQUESTREPORT"

/* LABREQUESTREPORTS */
export const GET_LABREQUESTREPORTS = "GET_LABREQUESTREPORTS"
export const GET_LABREQUESTREPORTS_SUCCESS = "GET_LABREQUESTREPORTS_SUCCESS"
export const GET_LABREQUESTREPORTS_FAIL = "GET_LABREQUESTREPORTS_FAIL"

/* LABREQUESTREPORT */
export const GET_LABREQUESTREPORT = "GET_LABREQUESTREPORT"
export const GET_LABREQUESTREPORT_SUCCESS = "GET_LABREQUESTREPORT_SUCCESS"
export const GET_LABREQUESTREPORT_FAIL = "GET_LABREQUESTREPORT_FAIL"

/**
 * ADD LABREQUESTREPORT
 */
 export const ADD_NEW_LABREQUESTREPORT = "ADD_NEW_LABREQUESTREPORT"
 export const ADD_LABREQUESTREPORT_SUCCESS = "ADD_LABREQUESTREPORT_SUCCESS"
 export const ADD_LABREQUESTREPORT_FAIL = "ADD_LABREQUESTREPORT_FAIL"

 /**
 * UPDATE LABREQUESTREPORT
 */
export const UPDATE_LABREQUESTREPORT = "UPDATE_LABREQUESTREPORT"
export const UPDATE_LABREQUESTREPORT_SUCCESS = "UPDATE_LABREQUESTREPORT_SUCCESS"
export const UPDATE_LABREQUESTREPORT_FAIL = "UPDATE_LABREQUESTREPORT_FAIL"

/**
 * DELETE LABREQUESTREPORT
 */
export const DELETE_LABREQUESTREPORT = "DELETE_LABREQUESTREPORT"
export const DELETE_LABREQUESTREPORT_SUCCESS = "DELETE_LABREQUESTREPORT_SUCCESS"
export const DELETE_LABREQUESTREPORT_FAIL = "DELETE_LABREQUESTREPORT_FAIL"
